module.exports = __webpack_public_path__ + "static/media/view_01_new.d83f7ecb.jpg";